/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputCreateTeamVideoLink
 */
export interface InputCreateTeamVideoLink {
    /**
     * 
     * @type {string}
     * @memberof InputCreateTeamVideoLink
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InputCreateTeamVideoLink
     */
    url: string;
}

/**
 * Check if a given object implements the InputCreateTeamVideoLink interface.
 */
export function instanceOfInputCreateTeamVideoLink(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('url' in value)) return false;
    return true;
}

export function InputCreateTeamVideoLinkFromJSON(json: any): InputCreateTeamVideoLink {
    return InputCreateTeamVideoLinkFromJSONTyped(json, false);
}

export function InputCreateTeamVideoLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputCreateTeamVideoLink {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'url': json['url'],
    };
}

export function InputCreateTeamVideoLinkToJSON(value?: InputCreateTeamVideoLink | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'url': value['url'],
    };
}

